import React, { Component } from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import { arrObjSorter } from 'utils/utils';
import { DateFormatter} from 'utils/DateFormatter';
import Constants from 'utils/Constants';
import { VictoryChart, VictoryBar, VictoryAxis, VictoryTooltip } from 'victory';
import styles from 'styles/components/series/tabbedGraphs/tabbedGraphContainer.css';
import theme from 'themes/victoryChartTheme';

export default class TicketSalesGraph extends Component {
  shouldComponentUpdate(nProps, nState) {
    return !Object.deepEquals(nProps.data, this.props.data);
  }
  getFormat = (tick) => {
    let format = (this.props.selectedUnit !== Constants.unit.month) ? 'TICK_DISPLAY' : 'MONTH_DISPLAY';
    return DateFormatter.format(tick, DateFormatter[format])
  }
  changeDataFormat = () => {
    let { data } = this.props;
    let newData = [];
    if(data) {
      newData = data.map((elem) => {
        let total = 0; // total to be displayed on bar graph
        let dateString = `${elem.label}`; // String for the date to be concated later
        let flexArr = []; // stores flex package sales so that similar sales can be grouped together
        let flexString = ''; // String for flex packages
        let fixedArr = []; // stores fixed plus package sales so that similar sales can be grouped together
        let tempFlexString = ''; // String for temporary storing similar sales for flex packages
        let fixedPlusTotal = 0; // Temp total for grouping similar Fixed Plus Package totals
        let fixedPlusString = ''; // String for fixed plus packages
        let ticketTypeString = ''; // String for Full Price
        let finalString = ''; // String to be returned to label

        // Loop to grab all sales that are FLEX PACKAGES and FIXED PLUS PACKAGES
        for (let key in elem) {
          if(elem[key].promotionId && elem[key].ticketTypeId) {
            flexArr.push(elem[key]);
          }
          if(elem[key].promotionId && elem[key].ticketTypeId === null) {
            fixedArr.push(elem[key]);
          }
        }

        arrObjSorter('promotionId', flexArr, fixedArr);

        // Loop to group the FLEX PACKAGE sales
        for (let i = 0; i < flexArr.length; i++) {
          // If next element has same promotionId(sale in similar flex package) and it is not the last element in array
          if (i !== flexArr.length-1 && flexArr[i].promotionId === flexArr[i+1].promotionId) {
            // store in tempFlexString to use later
            tempFlexString += `\n${flexArr[i].ticketTypeName}: ${numeral(flexArr[i].totalRevenueAsDouble).format('$0,0.00')}`
          // Either last element in array or not the same FLEX PACKAGE as the next element
          } else {
            // if tempFlexString is not empty, it means that it is part of the same FLEX PACKAGE as the previous
            if (tempFlexString !== '') {
              // Therefore add current element name
              tempFlexString += `\n${flexArr[i].ticketTypeName}: ${numeral(flexArr[i].totalRevenueAsDouble).format('$0,0.00')}`
              // Then concat the Flex Package name with the ticket names stored in tempFlexString
              flexString += `\n-----${flexArr[i].promotionName}-----${tempFlexString}`
              // clear tempFlexString for next use
              tempFlexString = '';
            // if it is empty, means its by itself
            } else {
              // Therefore concat normally
              flexString += `\n-----${flexArr[i].promotionName}-----\n${flexArr[i].ticketTypeName}: ${numeral(flexArr[i].totalRevenueAsDouble).format('$0,0.00')}`
            }
          }
        }

        // Loop to group the FIXED PLUS PACKAGE sales
        for (let i = 0; i < fixedArr.length; i++) {
          // If next element has same promotionId(sale in similar flex package) and it is not the last element in array
          if (i !== fixedArr.length-1 && fixedArr[i].promotionId === fixedArr[i+1].promotionId) {
            // store total in temp variable to use later
            fixedPlusTotal += fixedArr[i].totalRevenueAsDouble;
          // Either last element in array or not the same FIXED PLUS PACKAGE as the next element
          } else {
            // if fixedPlusTotal is not 0, it means that it is part of the same FIXED PLUS PACKAGE as the previous
            if (fixedPlusTotal !== 0) {
              // Therefore add current element total
              fixedPlusTotal += fixedArr[i].totalRevenueAsDouble;
              // Then concat the Flex Package name with the total stored in fixedPlusTotal
              fixedPlusString += `\n${fixedArr[i].promotionName}: ${numeral(fixedPlusTotal).format('$0,0.00')}`
              // clear fixedPlusTotal
              fixedPlusTotal = 0;
            // if it is empty, means its by itself
            } else {
              // Therefore concat normally
              fixedPlusString += `\n${fixedArr[i].promotionName}: ${numeral(fixedArr[i].totalRevenueAsDouble).format('$0,0.00')}`
            }
          }
        }

        // Loop through All the tickets to build strings
        for (let key in elem) {
          if( key !== 'label') {
            // Check for Fixed Plus Packages and Flex Packages
            if(elem[key].promotionId) {
              total += elem[key].totalRevenueAsDouble;
            // Check for Full Price
            } else {
              total += elem[key].totalRevenueAsDouble;
              ticketTypeString += `\n${elem[key].ticketTypeName}: ${numeral(elem[key].totalRevenueAsDouble).format('$0,0.00')}`;
            }
          }
        }
        // First Line
        finalString = `${dateString} - Total: ${numeral(total).format('$0,0.00')}`
        // Check if anything is in the strings
        if(ticketTypeString.length > 1) {
          finalString += `\n-------Full Price-------${ticketTypeString}`;
        }
        if(flexString.length > 1) {
          finalString += flexString;
        }
        if(fixedPlusString.length > 1) {
          finalString += `\n------Fixed Plus Packages------${fixedPlusString}`;
        }
        if (total === 0) {
          return {date: new Date(elem.label), value: total, label: dateString}
        } else {
          return {date: new Date(elem.label), value: total, label: finalString}
        }

      })
    }
    return newData;
  }
  getHighestValue = (arr) => {
    let highest = 0;
    arr.forEach((elem) => {
      if(elem.value > highest){
        highest = elem.value;
      }
    })
    return highest;
  }
  getSmallTickCount = (length) => {
    if (length < 3 ) return 1;
    else if (length < 10) return length;
    else return 10;
  }
  getBarWidth = () => {
    let length = this.changeDataFormat().length;
    if (length <= 7) {
      return {data: { width: 30 }};
    } else {
      return null;
    }
  }
  getTickValues = () => {
    let { data, selectedUnit } = this.props;
    let length = data.length;
    if (length === 1) {
      return [new Date(data[0].label)]
    } else if (selectedUnit === 'WEEK' && length < 11) {
      return data.map((elem) => {
        return new Date(elem.label)
      });
    } else {
      return null;
    }
  }
  render() {
    let { chartSize, isLoading } = this.props;
    let newData = this.changeDataFormat();
    let length = newData.length;
    let { width, height } = chartSize;
    let lastValue = this.getHighestValue(newData);
    if (lastValue === 0) lastValue = 200; // Deafaulting to 200 to remove warnings
    if (newData) { // get a minimum display
      newData.forEach((elem) => {
        if(elem.value !== 0 && (elem.value/lastValue) < .01) elem.value = lastValue * .01
      })
      return (
        <div className={styles.graph} >
          <h6 className="printOnly">{this.props.printUnit} Ticket Sales</h6>
            { !isLoading &&
              <div style={{width: "100%", height: "100%"}} >
                <VictoryChart
                  width={width}
                  height={height}
                  theme={theme}
                  domainPadding={50}>
                  <VictoryAxis
                    scale="time"
                    tickCount={this.getSmallTickCount(length)}
                    tickValues={this.getTickValues()}
                    tickFormat={(x) => this.getFormat(x)}
                    fixLabelOverlap={true}
                    />
                  <VictoryAxis
                    tickCount={5}
                    dependentAxis
                    domain={{y:[0,lastValue]}}
                    tickFormat={(x) => (x) ? numeral(x).format('$0a') : null}
                  />
                  <VictoryBar
                    animate={{
                      duration: 2000,
                      onLoad: { duration: 1000 }
                    }}
                    data={(newData) ? newData : 0}
                    domain={{y:[0,lastValue]}}
                    labelComponent={
                      <VictoryTooltip
                        height={(datum) => {return datum.label.split('\n').length * 16}}
                        orientation={(datum) => {
                            if (datum.eventKey < (length / 3)) return "right";
                            else if (datum.eventKey > (length * .66)) return "left"
                            else return "bottom"
                        }}
                        pointerLength={0}
                        dy={(datum) => {return (datum.label.split('\n').length < 5) ? 5 : datum.label.split('\n').length * -3}}
                        style={{textAnchor: 'start', fill: 'white', textAdjust: 'spacing'}}
                        flyoutStyle={{
                          stroke: "#666", fill: "#3B454A"
                        }}
                      />
                    }
                    style={this.getBarWidth()}
                    x="date"
                    y="value"/>
                  </VictoryChart>
              </div>
            }
        </div>
      );
    }
  }
}


TicketSalesGraph.propTypes = {
  data: PropTypes.array,
  ticketTypes: PropTypes.array
};

TicketSalesGraph.contextTypes = {
  media: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/scripts/components/series/tabbedGraphs/TicketSalesGraph.js